import service from "../services/collections.service";

export const collections = {
    namespaced: true,
    state: {
    },
    getters: {
    },
    actions: {
        async getCollections() {
            try {
                const response = await service.getCollections();
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async getPaginated(context, params) {
            try {
                const response = await service.getPaginated(params);
                return response;
            } catch (error) {
                console.error("Error fetching paginated data:", error);
                throw error.response;
            }
        },
        async save(context, data) {
            try {
                let response;
                if (data.id === 0) {
                    response = await service.createData(data);
                } else {
                    response = await service.updateData(data.id, data);
                }
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async delete(context, id) {
            try {
                const response = await service.deleteData(id);
                return response;
            } catch (error) {
                throw error.response;
            }
        },
    },
    mutations: {
    },
};
